import { EpimsBaseEntityDto } from './epim-base.dto';
export class SubGroupDto extends EpimsBaseEntityDto {

    SubGroupId: string;
    SubGroupName: string;  
    SubGroupCode: string; 
    GroupId: string;
    SubscriptionUserId: string;
    DivestmentStatusId: string;
    SubscriberId: string;
    SiteId: string;
    ModifiedById: string;
    CreatedById: string;
    dateUpdated: Date;
    dateCreated: Date;
    Version: Number;
}